module.exports = __webpack_public_path__ + "img/8-Look_Man-half.6eea1b9.png";